module.exports = __webpack_public_path__ + "img/medicine.635fe08d.png";